import { request } from "@/api/client";

export type MappingIssue = {
  label: string;
  issues: string[];
  event_date?: string | null;
};

export type AccountingHealth = {
  ok: boolean;
  missing: string[];
  shopify: Record<string, MappingIssue>;
  bank: Record<string, MappingIssue>;
  events: Record<string, MappingIssue>;
};

export async function fetchAccountingHealth(): Promise<AccountingHealth> {
  return request<AccountingHealth>("/accounting/health");
}

export type AccountingSetup = {
  needs_setup: boolean;
  health: AccountingHealth;
};

export async function fetchAccountingSetup(): Promise<AccountingSetup> {
  return request<AccountingSetup>("/accounting/setup");
}

export async function seedAccountingDefaults(): Promise<AccountingHealth> {
  return request<AccountingHealth>("/accounting/setup/seed", { method: "POST" });
}
